var url = {
  // getpackages: '/holidays/dom/getHolidays1.htm',
  getpackages: '/holidays/search/packages.htm',
  comparePackages: '/holidays/compare/packages.htm',
  getPackageMedia: '/holidays/packageMedia.htm',
  submitQuery: (window.lrsDetails && window.lrsDetails.lrsSubmitUrl) ? window.lrsDetails.lrsSubmitUrl : '/unifiedleadroutingservice/services/lead/submit',
  sendOTP: '/holidays/mobile/sendOTP.htm',
  verifyOTP: '/holidays/mobile/verifyOTP.htm',
  leadAdditionalDetails: (window.lrsDetails && window.lrsDetails.lrsUpdateUrl) ? window.lrsDetails.lrsUpdateUrl : '/unifiedleadroutingservice/services/lead/update',
  wait: '/holidays/wait.htm',
  getTypeOfLeadData: (window.leadFormHandlerApi) ? window.leadFormHandlerApi : '/unifiedleadroutingservice/services/lead/DESKTOP/getLeadFormMetaData'
}

export default url



// WEBPACK FOOTER //
// ./src/common/URLStore.js